<template>
  <div>
    <validation-provider
      :name="`${question._id}-${question.label}`"
      v-if="hasAnswer(answer) && isCheckboxType(question) && isRequired(question)"
      rules="required"
      mode="lazy"
      v-slot="{ errors }"
    >
      <h4 class="question_checkbox__title required" v-html="sanitizedQuestion + ' *'"></h4>
      <p class="question_checkbox__description">{{ question.attributes.description }}</p>
      <div class="question_checkbox__options">
        <div 
          v-for="option in question.attributes.options" 
          :key="`${question._id}-${option.value}`" 
          class="question_checkbox__option"
        >
          <input 
            type="checkbox" 
            :id="`${question._id}-${option.value}`" 
            :value="option.value" 
            v-model="checkboxValues"
            @change="updateAnswerValue"
          />
          <label :for="`${question._id}-${option.value}`">{{ option.label }}</label>
        </div>
      </div>
      <span v-if="errors.length > 0" class="text-danger">
        Campo de resposta obrigatória
      </span>
    </validation-provider>
    <validation-provider
      :name="`${question._id}-${question.label}`"
      v-if="hasAnswer(answer) && isCheckboxType(question) && !isRequired(question)"
      v-slot="{ errors }"
      mode="lazy"
    >
      <h4 class="question_checkbox__title" v-html="sanitizedQuestion"></h4>
      <p class="question_checkbox__description">{{ question.attributes.description }}</p>
      <div class="question_checkbox__options">
        <div 
          v-for="option in question.attributes.options" 
          :key="`${question._id}-${option.value}`" 
          class="question_checkbox__option"
        >
          <input 
            type="checkbox" 
            :id="`${question._id}-${option.value}`" 
            :value="option.value" 
            v-model="checkboxValues"
            @change="updateAnswerValue"
          />
          <label :for="`${question._id}-${option.value}`">{{ option.label }}</label>
        </div>
      </div>
      <div v-if="errors.length > 0">
        {{ errors[0] }}
      </div>
    </validation-provider>
  </div>
</template>

<style lang="scss" scoped>
.question_checkbox__title {
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #4F4F4F;
  margin: 10px 0;

  // Estilos para listas no conteúdo HTML
  ::v-deep ul {
    list-style-type: disc;
    list-style-position: outside;
    padding-left: 20px;
    margin: 10px 0;
    
    li {
      margin-bottom: 8px;
      line-height: 1.4;
    }
  }

  ::v-deep ol {
    list-style-type: decimal;
    list-style-position: outside;
    padding-left: 20px;
    margin: 10px 0;
    
    li {
      margin-bottom: 8px;
      line-height: 1.4;
    }
  }

  ::v-deep p {
    margin: 8px 0;
    line-height: 1.4;
  }

  ::v-deep br {
    line-height: 1.4;
  }

  ::v-deep strong {
    font-weight: 600;
  }

  ::v-deep em {
    font-style: italic;
  }

  ::v-deep a {
    color: #4169E1;
    text-decoration: underline;
    
    &:hover {
      color: darken(#4169E1, 15%);
    }
  }
}

.question_checkbox__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  color: #4F4F4F; 
  margin-bottom: 10px;
}
.question_checkbox__options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.question_checkbox__option {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0.5px solid #D4D4D4;
  border-radius: 8px;
  padding: 8px 16px;
  
  input[type="checkbox"] {
    appearance: none;
    background-color: #fff;
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    flex-shrink: 0;
    border: 1px solid #BDBDBD;
    border-radius: 2px;
    position: relative;
    cursor: pointer;
    
    &:checked {
      background-color: #4169E1;
      border-color: #4169E1;
      
      &:after {
        content: "";
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }
    }
  }
  
  label {
    font-size: 16px;
    color: #4F4F4F;
    cursor: pointer;
  }
}

.required {
  color: #333333;
}
</style>

<script>
import { ValidationProvider } from "vee-validate";
import { sanitizeBasicHtml } from "@/utils/htmlSanitizer";

export default {
  components: { ValidationProvider },
  name: "question-checkbox",
  props: {
    answer: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      checkboxValues: []
    };
  },
  computed: {
    sanitizedQuestion() {
      return sanitizeBasicHtml(this.question.question);
    },
    optionsExist() {
      return this.question.attributes.options && Array.isArray(this.question.attributes.options) && this.question.attributes.options.length > 0;
    }
  },
  methods: {
    hasAnswer: answer => Object.keys(answer).length > 0,
    isCheckboxType: question => question.type === "checkbox",
    isRequired: question => question.required,
    updateAnswerValue() {
      this.answer.value = [...this.checkboxValues];
    }
  },
  created() {
    if (this.answer.value) {
      if (Array.isArray(this.answer.value)) {
        this.checkboxValues = this.answer.value;
      } else if (typeof this.answer.value === 'string') {
        this.checkboxValues = this.answer.value.split(',').filter(val => val.trim() !== '');
        this.answer.value = this.checkboxValues;
      }
    }
    
    if (!this.optionsExist && this.isCheckboxType(this.question)) {
      this.question.attributes.options = [];
    }
  }
};
</script> 